module.exports = __webpack_public_path__ + "img/component-instance.6746a31c.svg";